export const pt = {
    toLoginAfterConfirmTitle: `Redirecionando para o login...`,
    toLoginAfterConfirmDescription: `Agora você pode entrar. Redirecionando para a página de login...`,
    toLoginAfterResetTitle: `Senha redefinida`,
    toLoginAfterResetDescription: `Agora você pode entrar com sua nova senha. Redirecionando para a página de login...`,
    toResendConfirmationTitle: `Redirecionando para opções de confirmação por e-mail...`,
};
//# sourceMappingURL=pt.js.map